export default __webpack_public_path__ + "static/media/berrycake@3x.adbc3621.jpg";